const routes = [
  {
    path: '/app/dashboard',
    icon: 'HomeIcon',
    name: 'common.menus.dashboard',
    key: '1',
  },
  {
    icon: 'Factory',
    name: 'common.menus.monitor',
    key: '2',
    routes: [
      {
        path: '/app/sites',
        icon: 'Factory',
        name: 'common.menus.factories',
        key: '2-1',
      },
      {
        path: '/app/report-devices',
        icon: 'ListDeviceIcon',
        name: 'common.menus.realtimeTable',
        key: '2-2',
      },
      {
        path: '/app/diagram',
        icon: 'DiagramIcon',
        name: 'common.menus.diagram',
        key: '2-3',
      },
      {
        path: '/app/architecture',
        icon: 'DiagramIcon',
        name: 'common.menus.architecture',
        key: '2-4',
      },
    ],
  },
  {
    path: '/app/reports',
    icon: 'ReportIcon',
    name: 'common.menus.reports',
    key: '3',
    routes: [
      {
        path: '/app/reports',
        icon: 'ReportIcon',
        name: 'common.menus.table',
        key: '3-1',
      },
      {
        path: '/app/charts',
        icon: 'ChartsIcon',
        name: 'common.menus.charts',
        key: '3-2',
      },
      {
        icon: 'InvoiceIcon',
        path: '/setting/invoice',
        name: 'common.menus.invoice',
        key: '3-3',
      },
      // {
      //   path: '/app/charts-compare',
      //   icon: 'TrendIcon',
      //   name: 'common.menus.compare',
      //   key: '3-3',
      // },
    ],
  },
  {
    path: '/app/alerts',
    icon: 'AlertIcon',
    name: 'common.menus.alerts',
    key: '4',
  },
  {
    icon: 'SettingIcon',
    name: 'common.menus.setting',
    key: 'setting',
    routes: [
      {
        icon: 'GeneralIcon',
        path: '/setting/dashboard',
        name: 'common.menus.dashboard',
        key: '5-1',
      },
      {
        icon: 'UsersIcon',
        path: '',
        name: 'common.menus.users',
        key: 'users',
        isAdmin: true,
        isManager: true,
      },
      {
        icon: 'CurrencyIcon',
        path: '/setting/prices',
        name: 'common.menus.price',
        key: '5-3',
      },
      {
        icon: 'AlertIcon',
        path: '/setting/alerts-setting',
        name: 'common.menus.alertSetting',
        key: '5-4',
      },
      {
        icon: 'MailIcon',
        path: '/setting/emails',
        name: 'common.menus.email',
        key: '5-5',
      },
    ],
  },
  {
    icon: 'DeviceIcon',
    name: 'common.menus.deviceSetting',
    key: 'deviceSetting',
    routes: [
      {
        icon: 'ListDeviceIcon',
        path: '/app/devices',
        name: 'common.menus.listDevices',
        key: '6-1',
      },
      {
        path: '/app/models',
        icon: 'DeviceModelIcon',
        name: 'common.menus.deviceModel',
        key: '6-3',
      },
      {
        path: '/app/items',
        icon: 'ItemsIcon',
        name: 'common.menus.items',
        key: '6-4',
      },
      {
        path: '/app/protocols',
        icon: 'ProtocolIcon',
        name: 'common.menus.protocols',
        key: '6-5',
      },
      {
        path: '/app/channels',
        icon: 'ChannelIcon',
        name: 'common.menus.channel',
        key: '6-6',
      },
      {
        icon: 'SettingIcon',
        path: '/setting/reboot-system',
        name: 'common.menus.rebootSystem',
        key: '5-6',
        isAdmin: true,
        isManager: true,
      },
    ],
  },
];

export default routes;
